import {
  incrementChatAnimationCounter,
  setPrevPathCookie,
  setAnimationShownCountCookie,
} from '../../containers/ConsultantCianChat/utils/chatAnimationCounter';
import { actionGenerator } from '../../utils/actionGenerator';
import { IThunkActionCreator } from '../../types/thunk';

export enum EConsultantCianChatActionTypes {
  OpenAutorisationMotivationPopup = 'consultantCianChat/autorisationMotivationPopupOpen',
  CloseAutorisationMotivationPopup = 'consultantCianChat/autorisationMotivationPopupClose',
  OpenChat = 'consultantCianChat/open',
  CloseChat = 'consultantCianChat/close',
  SetChatLoading = 'consultantCianChat/setChatLoading',
  OpenErrorMessage = 'consultantCianChat/OpenErrorMessage',
  CloseErrorMessage = 'consultantCianChat/CloseErrorMessage',
  SetAnimationCounter = 'consultantCianChat/setAnimationCounter',
  SetAnimationDelayMs = 'consultantCianChat/setAnimationDelayMs',
  SetAnimationShownCount = 'consultantCianChat/setAnimationShownCount',
}

export const setAnimationDelayMs = actionGenerator<EConsultantCianChatActionTypes.SetAnimationDelayMs, number>(
  EConsultantCianChatActionTypes.SetAnimationDelayMs,
);

export const incrementAnimationDelayMs = (): IThunkActionCreator => (dispatch, getState) => {
  const state = getState();
  const currentDelayMs = state.consultantCianChat.animationDelayMs;
  dispatch(setAnimationDelayMs(currentDelayMs + 1));
};

export const openConsultantCianChat = actionGenerator<EConsultantCianChatActionTypes.OpenChat, string>(
  EConsultantCianChatActionTypes.OpenChat,
);

export const closeConsultantCianChat = actionGenerator<EConsultantCianChatActionTypes.CloseChat, void>(
  EConsultantCianChatActionTypes.CloseChat,
);

export const openAutorisationMotivationConsultantCianChat = actionGenerator<
  EConsultantCianChatActionTypes.OpenAutorisationMotivationPopup,
  void
>(EConsultantCianChatActionTypes.OpenAutorisationMotivationPopup);

export const closeAutorisationMotivationConsultantCianChat = actionGenerator<
  EConsultantCianChatActionTypes.CloseAutorisationMotivationPopup,
  void
>(EConsultantCianChatActionTypes.CloseAutorisationMotivationPopup);

export const setChatLoading = actionGenerator<EConsultantCianChatActionTypes.SetChatLoading, void>(
  EConsultantCianChatActionTypes.SetChatLoading,
);

export const openErrorMessage = actionGenerator<EConsultantCianChatActionTypes.OpenErrorMessage, void>(
  EConsultantCianChatActionTypes.OpenErrorMessage,
);

export const closeErrorMessage = actionGenerator<EConsultantCianChatActionTypes.CloseErrorMessage, void>(
  EConsultantCianChatActionTypes.CloseErrorMessage,
);

export const setAnimationCounter = actionGenerator<EConsultantCianChatActionTypes.SetAnimationCounter, number>(
  EConsultantCianChatActionTypes.SetAnimationCounter,
);

export const setAnimationShownCountAction = actionGenerator<
  EConsultantCianChatActionTypes.SetAnimationShownCount,
  number
>(EConsultantCianChatActionTypes.SetAnimationShownCount);

export const setAnimationShownCount = (count: number): IThunkActionCreator => {
  return dispatch => {
    setAnimationShownCountCookie(count);
    dispatch(setAnimationShownCountAction(count));
  };
};

export const incrementAnimationCounter = (): IThunkActionCreator => {
  return dispatch => {
    dispatch(incrementAnimationDelayMs());
    const newCounter = incrementChatAnimationCounter();
    dispatch(setAnimationCounter(newCounter));
    const currentPath = window.location.pathname + window.location.search;
    if (currentPath) {
      setPrevPathCookie(currentPath);
    }
  };
};

export type TConsultantCianChatActions =
  | ReturnType<typeof openConsultantCianChat>
  | ReturnType<typeof closeConsultantCianChat>
  | ReturnType<typeof openAutorisationMotivationConsultantCianChat>
  | ReturnType<typeof closeAutorisationMotivationConsultantCianChat>
  | ReturnType<typeof openErrorMessage>
  | ReturnType<typeof setChatLoading>
  | ReturnType<typeof closeErrorMessage>
  | ReturnType<typeof setAnimationCounter>
  | ReturnType<typeof setAnimationDelayMs>
  | ReturnType<typeof setAnimationShownCountAction>;
